import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=31c17a04&scoped=true&style=border-radius%3A%2010px"
import script from "./ModalView.vue?vue&type=script&lang=js"
export * from "./ModalView.vue?vue&type=script&lang=js"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=31c17a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c17a04",
  null
  
)

export default component.exports